// ChangePasswordHospitalModel



import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useDispatch } from 'react-redux';
import { hospitalActions } from '../../../_actions/hospital.actions'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { userActions } from '../../../_actions';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  // border: '2px solid #000',  // Add this line for border
  borderRadius: '8px',       // Add this line for rounded corners
  boxShadow: 24,
  p: 4,
};

export default function ChangePasswordPhysioModel({ setOpen, open }) {

  const dispatch = useDispatch()
  const [fieldsUser, setFieldsUser] = React.useState({});
  const [error, setErrors] = React.useState({});


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFieldsUser((prevFields) => ({ ...prevFields, [name]: value }));
    setErrors({ ...error, [name]: "" })
  };

  const handleValidationUserInfo = () => {
    let formIsValid = true;
    let newErrors = {};

    if (!fieldsUser.NewPassword) {
      formIsValid = false;
      newErrors = { ...newErrors, NewPassword: 'Enter a new password' };
    }



    if (!fieldsUser.NewPassword || fieldsUser.NewPassword.length < 8) {
      formIsValid = false;
      newErrors = { ...newErrors, NewPassword: 'Password must be at least 8 characters long' }
    } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}/.test(fieldsUser.NewPassword)) {
      formIsValid = false;
      newErrors = { ...newErrors, NewPassword: 'Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character' }
    }






    if (!fieldsUser.ConfirmPassword) {
      formIsValid = false;
      newErrors = { ...newErrors, ConfirmPassword: 'Enter a confirm password' };
    }
    if (fieldsUser.NewPassword !== fieldsUser.ConfirmPassword) {
      formIsValid = false;
      newErrors = { ...newErrors, ConfirmPassword: 'Passwords do not match' };
    }












    setErrors(newErrors);
    return formIsValid;
  };


  const submitDetails = (e) => {
    e.preventDefault();
    console.log(fieldsUser)
    if (handleValidationUserInfo()) {
      let data = {
        newPassword: fieldsUser.NewPassword,
        password: fieldsUser.ConfirmPassword
      }
      dispatch(userActions.updatePassword(data));
      setFieldsUser({})
      handleClose()
    }
  };
  let handleClose = () => {
    setFieldsUser({})
    setOpen(false)
  }

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const togglePasswordVisibilityConfirm = () => {
    setShowPasswordConfirm(!showPasswordConfirm);
  };

  return (

    <div>
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >

        <Box sx={style}>

          <Box className='bg-[#005F60] rounded-xl flex justify-between items-center '>
            <Box className="px-3 py-2 text-white font-bold" >Change Password</Box>
            <Box className="px-3 py-2 text-white font-bold"><CloseRoundedIcon onClick={handleClose} className=" cursor-pointer text-white font-bold" /></Box>
          </Box>



          <form className="max-w-md mx-auto mt-6 space-y-6">


            <div className='flex flex-col gap-3'>

              {/* <div>
                <label htmlFor="NewPassword" className="block text-sm font-medium text-gray-700">
                  New Password
                </label>
                <input
                  id="NewPassword"
                  name="NewPassword"
                  type="password"
                  placeholder="Enter NewPassword "
                  className={`mt-1 p-2 w-full rounded-md border ${error.NewPassword ? 'border-red-500' : 'border-gray-300'
                    } focus:outline-none focus:border-blue-500`}
                  value={fieldsUser.NewPassword || ''}
                  onChange={handleChange}
                />
                {error['NewPassword'] && <p className='text-sm text-red-500'>{error.NewPassword}</p>}
              </div> */}


              <div>
                <label htmlFor="NewPassword" className="block text-sm font-medium text-gray-700">
                  New Password
                </label>
                <div className="relative">
                  <input
                    id="NewPassword"
                    name="NewPassword"
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Enter New Password"
                    className={`mt-1 p-2 w-full text-xs rounded-md border ${error.NewPassword ? 'border-red-500' : 'border-gray-300'
                      } focus:outline-none focus:border-blue-500`}
                    value={fieldsUser.NewPassword || ''}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-700 focus:outline-none"
                  >
                    {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                  </button>
                </div>
                {error['NewPassword'] && <p className="text-sm text-red-500">{error.NewPassword}</p>}
              </div>



              <div>
                <label htmlFor="ConfirmPassword" className="block text-sm font-medium text-gray-700">
                  Confirm Password
                </label>
                <div className="relative">
                  <input
                    id="ConfirmPassword"
                    name="ConfirmPassword"
                    type={showPasswordConfirm ? 'text' : 'password'}
                    placeholder="Enter Confirm Password"
                    className={`mt-1 p-2 w-full rounded-md border ${error.ConfirmPassword ? 'border-red-500' : 'border-gray-300'
                      } focus:outline-none focus:border-blue-500`}
                    value={fieldsUser.ConfirmPassword || ''}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibilityConfirm}
                    className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-700 focus:outline-none"
                  >
                    {showPasswordConfirm ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                  </button>
                </div>
                {error['ConfirmPassword'] && <p className="text-sm text-red-500">{error.ConfirmPassword}</p>}
              </div>

              {/* <div>
                <label htmlFor="ConfirmPassword" className="block text-sm font-medium text-gray-700">
                  Confirm Password
                </label>
                <input
                  id="ConfirmPassword"
                  name="ConfirmPassword"
                  type="password"
                  placeholder="Enter ConfirmPassword"
                  className={`mt-1 p-2 w-full rounded-md border ${error.ConfirmPassword ? 'border-red-500' : 'border-gray-300'
                    } focus:outline-none focus:border-blue-500`}
                  value={fieldsUser.ConfirmPassword || ''}
                  onChange={handleChange}
                />
                {error['ConfirmPassword'] && <p className='text-sm text-red-500'>{error.ConfirmPassword}</p>}
              </div> */}




            </div>




            <button
              onClick={submitDetails}
              type="button"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#005F60] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Submit
            </button>
          </form>

        </Box>
      </Modal>
    </div>
  );
}